import * as Font from "expo-font";

export const loadFonts = async () => {
  await Font.loadAsync({
    DmMono: require("./assets/fonts/DmMono.ttf"),
    Manrope: require("./assets/fonts/Manrope.ttf"),
    Inter: require("./assets/fonts/Inter.ttf"),
    Montserrat: require("./assets/fonts/Montserrat-Regular.ttf"),
    AbrilFatface: require("./assets/fonts/AbrilFatface-Regular.ttf"),
    MontrealBold: require("./assets/fonts/MontrealBold.ttf"),
    MontrealBook: require("./assets/fonts/MontrealBook.ttf"),
    MontrealMedium: require("./assets/fonts/MontrealMedium.ttf"),
    MaterialCommunityIcons: require("./assets/fonts/MaterialCommunityIcons.ttf"),
  });
};
